import {Injectable} from "@angular/core";
import {HttpObservable, HttpWrapper} from "../../common/http-helpers/http.wrapper";

@Injectable({
  providedIn: "root"
})
export class LicenseProxy {
  constructor(private httpWrapper: HttpWrapper) {}

  public validateLicense(): HttpObservable<boolean> {
    return this.httpWrapper.getAnon('PatientPortalLicense', 'ValidateLicense');
  }
}
